import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'on-remove-invitation-gridcell',
    templateUrl: './remove-invitation-gridcell.component.html',
    styleUrls: ['./remove-invitation-gridcell.component.scss'],
})
export class RemoveInvitationGridcellComponent
    implements ICellRendererAngularComp
{
    params: any;

    constructor() {}

    removeInvitation(event) {
        this.params.context.parent.removeInvitation(this.params.data);
    }

    refresh(params: any): boolean {
        return false;
    }
    agInit(params: import('ag-grid-community').ICellRendererParams): void {
        this.params = params;
    }
    afterGuiAttached?(
        params?: import('ag-grid-community').IAfterGuiAttachedParams,
    ): void {}
}
